var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap24 = function SvgMap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.56 5.172A1 1 0 0 1 21 6v10a1 1 0 0 1-.629.928l-5 2a1 1 0 0 1-.687.02L9.03 17.065l-4.66 1.864A1 1 0 0 1 3 18V8a1 1 0 0 1 .629-.928l5-2a1 1 0 0 1 .687-.02l5.653 1.883 4.66-1.863a1 1 0 0 1 .932.1ZM5 8.677l3-1.2v7.846l-3 1.2V8.677Zm9 7.936-4-1.334V7.387l4 1.334v7.892Zm2-.09 3-1.2V7.477l-3 1.2v7.846Z",
    fill: "currentColor",
    fillOpacity: 0.64
  })));
};
export default SvgMap24;